// Libs
import React from 'react'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

// CSS
import "./styles.scss"

const NotFoundBox = ({ img, title, text, marginTop }) => {
  const notFoundBoxStyle = {
    marginTop: `${marginTop}px`
  }

  return (
    <div
      style={notFoundBoxStyle}
      className="not-found-box">
      <Isvg
        src={img}
        className="my-cases-page__img" />
      <p>{title}</p>
      <p>{text}</p>
    </div>
  )
}

export default NotFoundBox
